import { render, staticRenderFns } from "./behavioral.vue?vue&type=template&id=6cfd9b56&scoped=true&"
import script from "./behavioral.vue?vue&type=script&lang=js&"
export * from "./behavioral.vue?vue&type=script&lang=js&"
import style0 from "./behavioral.vue?vue&type=style&index=0&id=6cfd9b56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd9b56",
  null
  
)

export default component.exports